(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("fuzzysearch"), require("react-motion"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "fuzzysearch", "react-motion"], factory);
	else if(typeof exports === 'object')
		exports["demopage"] = factory(require("prop-types"), require("react"), require("fuzzysearch"), require("react-motion"));
	else
		root["demopage"] = factory(root["prop-types"], root["react"], root["fuzzysearch"], root["react-motion"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(7).default;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(6).default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _SimpleAutocompleteModule = __webpack_require__(10);

var _SimpleAutocompleteModule2 = _interopRequireDefault(_SimpleAutocompleteModule);

var _fuzzysearch = __webpack_require__(12);

var _fuzzysearch2 = _interopRequireDefault(_fuzzysearch);

var _VerticalList = __webpack_require__(0);

var _VerticalList2 = _interopRequireDefault(_VerticalList);

var _reactMotion = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleAutocomplete = function (_Component) {
  _inherits(SimpleAutocomplete, _Component);

  function SimpleAutocomplete(props) {
    _classCallCheck(this, SimpleAutocomplete);

    var _this = _possibleConstructorReturn(this, (SimpleAutocomplete.__proto__ || Object.getPrototypeOf(SimpleAutocomplete)).call(this, props));

    _this.state = {
      value: props.defaultValue,
      isFocused: false
    };
    return _this;
  }

  _createClass(SimpleAutocomplete, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.defaultValue !== nextProps.defaultValue) {
        this.setState({ value: nextProps.defaultValue });
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this._input) {
        this._input.focus();
      }
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(event) {
      var value = event.target.value;
      this.setState({ value: value });
      this.props.onChange(event, value);
    }
  }, {
    key: 'handleItemClick',
    value: function handleItemClick(event, key) {
      this.props.onSelect(event, key);
      this._input.blur();
    }
  }, {
    key: 'filterItems',
    value: function filterItems(items, filter, searchQuery) {
      return items.filter(function (item) {
        return filter(item.value, searchQuery);
      });
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.focus();
      this.setState({ isFocused: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({ isFocused: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          defaultValue = _props.defaultValue,
          filter = _props.filter,
          items = _props.items,
          maxSuggessionsHeight = _props.maxSuggessionsHeight,
          onChange = _props.onChange,
          onSelect = _props.onSelect,
          inputElement = _props.inputElement,
          placeholder = _props.placeholder,
          origin = _props.origin,
          restProps = _objectWithoutProperties(_props, ['defaultValue', 'filter', 'items', 'maxSuggessionsHeight', 'onChange', 'onSelect', 'inputElement', 'placeholder', 'origin']);

      var _state = this.state,
          value = _state.value,
          isFocused = _state.isFocused;

      var filteredItems = this.filterItems(items, filter, value);
      var inputProps = _extends({
        ref: function (ref) {
          return _this2._input = ref;
        }.bind(this),
        value: value,
        placeholder: placeholder,
        onChange: this.handleInputChange.bind(this)
      }, restProps);

      var input = inputElement ? inputElement(inputProps) : _react2.default.createElement('input', _extends({ className: _SimpleAutocompleteModule2.default.input }, inputProps));

      var showSuggessions = isFocused && filteredItems.length;
      var motionPreset = _reactMotion.presets.stiff;
      var suggessionsContainer = _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: 0, y: 0 },
          style: {
            x: showSuggessions ? (0, _reactMotion.spring)(maxSuggessionsHeight, motionPreset) : (0, _reactMotion.spring)(0, motionPreset),
            y: showSuggessions ? (0, _reactMotion.spring)(1, motionPreset) : (0, _reactMotion.spring)(0, motionPreset)
          }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            'div',
            {
              className: '\n            ' + _SimpleAutocompleteModule2.default.suggessionsContainer + '\n            ' + (origin === 'top' ? _SimpleAutocompleteModule2.default.suggessionsContainerTop : ' ') + '\n          ',
              style: {
                maxHeight: interpolatedStyle.x + 'px',
                opacity: interpolatedStyle.y
              }
            },
            _react2.default.createElement(
              'div',
              { className: _SimpleAutocompleteModule2.default.suggessions },
              _react2.default.createElement(_VerticalList2.default, {
                items: filteredItems,
                onClick: function onClick(event, key) {
                  return _this2.handleItemClick(event, key);
                }
              })
            )
          );
        }
      );

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(_ref) {
            return _this2._autocomplete = _ref;
          },
          tabIndex: -1,
          className: _SimpleAutocompleteModule2.default.simpleAutocomplete,
          onFocus: this.handleFocus.bind(this),
          onBlur: this.handleBlur.bind(this)
        },
        input,
        suggessionsContainer
      );
    }
  }]);

  return SimpleAutocomplete;
}(_react.Component);

exports.default = SimpleAutocomplete;


SimpleAutocomplete.propTypes = {
  defaultValue: _propTypes2.default.string,
  filter: _propTypes2.default.func,
  inputElement: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string,
    value: _propTypes2.default.string
  })),
  onChange: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  origin: _propTypes2.default.oneOf(['top', 'bottom']),
  maxSuggessionsHeight: _propTypes2.default.number
};
SimpleAutocomplete.defaultProps = {
  defaultValue: '',
  filter: function filter(value1, value2) {
    return (0, _fuzzysearch2.default)(value2.toLowerCase(), value1.toLowerCase());
  },
  items: [],
  maxSuggessionsHeight: 320,
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  origin: 'bottom',
  placeholder: ''
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _VerticalListModule = __webpack_require__(11);

var _VerticalListModule2 = _interopRequireDefault(_VerticalListModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VerticalList = function (_Component) {
  _inherits(VerticalList, _Component);

  function VerticalList() {
    _classCallCheck(this, VerticalList);

    return _possibleConstructorReturn(this, (VerticalList.__proto__ || Object.getPrototypeOf(VerticalList)).apply(this, arguments));
  }

  _createClass(VerticalList, [{
    key: 'handleItemClick',
    value: function handleItemClick(event, key) {
      var onClick = this.props.onClick;

      onClick(event, key);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          onClick = _props.onClick,
          restProps = _objectWithoutProperties(_props, ['items', 'onClick']);

      return _react2.default.createElement(
        'div',
        _extends({ className: _VerticalListModule2.default.verticalList }, restProps),
        items.map(function (item) {
          return _react2.default.createElement(
            'div',
            {
              className: _VerticalListModule2.default.item,
              key: item.key,
              onClick: function onClick(event) {
                return _this2.handleItemClick.call(_this2, event, item.key);
              }
            },
            item.value
          );
        })
      );
    }
  }]);

  return VerticalList;
}(_react.Component);

exports.default = VerticalList;


VerticalList.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string,
    value: _propTypes2.default.node
  })),
  onClick: _propTypes2.default.func
};
VerticalList.defaultProps = {
  items: [],
  onClick: function onClick() {}
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".SimpleAutocomplete-module__simpleAutocomplete__3-0-1_38C {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n  position: relative;\n}\n.SimpleAutocomplete-module__input__3-0-1_1gr {\n  border: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n  font-size: 16px;\n}\n.SimpleAutocomplete-module__input__3-0-1_1gr::-webkit-input-placeholder {\n  color: #333;\n  opacity: 0.6;\n}\n.SimpleAutocomplete-module__input__3-0-1_1gr::-moz-placeholder {\n  color: #333;\n  opacity: 0.6;\n}\n.SimpleAutocomplete-module__input__3-0-1_1gr:-ms-input-placeholder {\n  color: #333;\n  opacity: 0.6;\n}\n.SimpleAutocomplete-module__input__3-0-1_1gr::placeholder {\n  color: #333;\n  opacity: 0.6;\n}\n.SimpleAutocomplete-module__input__3-0-1_1gr:focus {\n  outline: none;\n}\n.SimpleAutocomplete-module__suggessionsContainer__3-0-1_hZ- {\n  background-color: #fff;\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n  bottom: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  left: 0;\n  min-width: 100%;\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  top: 100%;\n  z-index: 999;\n}\n.SimpleAutocomplete-module__suggessionsContainerTop__3-0-1_3_5 {\n  top: auto;\n  bottom: 100%;\n}\n.SimpleAutocomplete-module__suggessionsContainer__3-0-1_hZ-:focus {\n  outline: none;\n}\n.SimpleAutocomplete-module__suggessions__3-0-1_2YW {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  max-height: inherit;\n  overflow: auto;\n  position: relative;\n}\n", ""]);

// exports
exports.locals = {
	"simpleAutocomplete": "SimpleAutocomplete-module__simpleAutocomplete__3-0-1_38C",
	"input": "SimpleAutocomplete-module__input__3-0-1_1gr",
	"suggessionsContainer": "SimpleAutocomplete-module__suggessionsContainer__3-0-1_hZ-",
	"suggessionsContainerTop": "SimpleAutocomplete-module__suggessionsContainerTop__3-0-1_3_5",
	"suggessions": "SimpleAutocomplete-module__suggessions__3-0-1_2YW"
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, ".VerticalList-module__item__3-0-1_2Fo {\n  position: relative;\n  padding: 6px 12px;\n}\n.VerticalList-module__item__3-0-1_2Fo:focus {\n  outline: none;\n}\n.VerticalList-module__item__3-0-1_2Fo:hover:after {\n  content: '';\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.08);\n}\n", ""]);

// exports
exports.locals = {
	"item": "VerticalList-module__item__3-0-1_2Fo"
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/index.js??ref--2-3!./SimpleAutocomplete.module.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/index.js??ref--2-3!./SimpleAutocomplete.module.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/index.js??ref--2-3!./VerticalList.module.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/less-loader/index.js??ref--2-3!./VerticalList.module.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("fuzzysearch");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = require("react-motion");

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Here should be es2016 or CommonJS exports.

module.exports = {
  SimpleAutocomplete: __webpack_require__(5).default,
  VerticalList: __webpack_require__(0).default
};

/***/ })
/******/ ]);
});


//////////////////
// WEBPACK FOOTER
// ./~/@opuscapita/react-autocompletes/lib/index.js
// module id = 1791
// module chunks = 0